import ProfileContainer from 'views/profile/Profile.container';

export default ProfileContainer;
